import { fullNamePresenter } from 'utils';
import { prepareDoctorName } from 'infrastructure/functions';

import type { IPatientCallHistory } from 'infrastructure/interfaces/i-patient-call-history';

export class PatientCallHistory {
  callId: string;
  patientGuid: string;
  patientFullname: string | null;
  createdBy: string;
  createdAt: string;
  type: string;
  callerFullname: string | null;
  initiationMethod: string;
  duration: number;
  constructor(data: IPatientCallHistory) {
    this.callId = data.callId;
    this.patientGuid = data.patientGuid;
    this.createdBy = data.createdBy;
    this.createdAt = data.createdAt;
    this.type = data.type;
    this.initiationMethod = data.initiationMethod;
    this.duration = data.duration;
    this.patientFullname = fullNamePresenter({
      title: data.patientTitle,
      firstName: data.patientFirstName,
      middleName: data.patientMiddleName,
      lastName: data.patientLastName,
    });
    this.callerFullname = prepareDoctorName({
      title: data.callerTitle,
      firstName: data.callerFirstName,
      professionType: data.callerProfessionType,
      lastName: data.callerLastName,
    });
  }
}
